export default {
	name: "זהות",
	logo: "/img/logo.png",

	rtl: true
};
